interface Props {
  values: string[]
}

const Option = ({ values }: Props) => {
  return (
    <>
      {values.map((value, index) => (
        <span key={`${value}-${index}`} data-testid='option-name' title={value}>
          {(!!index ? ', ' : ' ') + value}
        </span>
      ))}
    </>
  )
}

export default Option
